const requestAnimationFrame = window.requestAnimationFrame
  || window.webkitRequestAnimationFrame
  || window.mozRequestAnimationFrame
  || window.msRequestAnimationFrame
  || function requestAnimationFrame(callback) { return setTimeout(callback, 16); };

async function runTasks(tasks) {
  await Promise.all(tasks.map(task => task()));
}

class QueuedTask {
  constructor({ batchSize = 15 } = {}) {
    this.batchSize = batchSize;
    this.tasks = [];
  }

  enqueue(task) {
    this.tasks.push(task);
    this.scheduleFlush();
  }

  scheduleFlush() {
    if (!this.scheduled) {
      this.scheduled = true;
      requestAnimationFrame(this.flush.bind(this));
    }
  }

  async flush() {
    await runTasks(this.tasks.splice(0, this.batchSize));

    this.scheduled = false;
    if (this.tasks.length) this.scheduleFlush();
  }
}

const queuedTask = new QueuedTask();

export function enqueueTask(task) {
  queuedTask.enqueue(task);
  return task;
}
